(function () {
  angular
    .module("akitabox.mobile.directives.pinValueList")
    .directive("abmPinValueList", AbmPinValueListDirective);

  /** @ngInject */
  function AbmPinValueListDirective($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/pin-value-list/pin-value-list.html",
      controller: "PinValueListController", // Use core pin value list in core/modules/pin-value
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        building: "=",
        pin: "=",
        isRoom: "=?",
        isAsset: "=?",
        values: "=",
        onChange: "&",
        readonlyLevel: "<?",
        readonlyRoom: "<?",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      $timeout(function () {
        vm.readonly = attrs.readonly;
      });
    }
  }
})();
